/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GetFieldWeightsRequest = core.serialization.object({
    sourceFields: core.serialization.list(core.serialization.string()),
    destinationFields: core.serialization.list(core.serialization.string()),
});
